module.exports = __webpack_public_path__ + "img/logo_desk_vet.ebe1402c.png";